/**
 * Wraps tables and adds scroll to tables if they get too long
 * <div class="c-table-wrapper  js-table-wrapper">
 *	  <div class="c-table-wrapper__inner">
 *		  <table>
 *          ...
 *
 */

import $ from 'jquery';

// Module init
export default function init() {
	// Can't use element variables because this is also being used on
	// a page with handlebars generated content so the selectors have to be live
	if (!$('.js-table-wrapper').length) return;

	$('.js-table-wrapper').each(function() {
		const $table = $(this);

		if (childIsOverflowing($table)) {
			$table.addClass('is-overflowed');
		} else {
			$table.removeClass('is-overflowed');
		}
	});
}

// Private functions
export function childIsOverflowing($table) {
	const tableWidth = $table.outerWidth();
	const childWidth = $table.find('table').outerWidth();
	return tableWidth < childWidth;
}

export function resize() {
	if (!Modernizr.touch) {
		init();
	}
}
